export const EliSuggestionButtonPlacement = {
	Default: 'default',
	Compact: 'compact',
} as const;

export const EliSuggestionPlacement = {
	ProjectHeader: 'project-header',
	BookingsHeader: 'bookings-header',
} as const;

export const ANALYZE_PROJECT_HEALTH_SUGGESTION_ID = 'analyze-project-health';
export const REBALANCE_BOOKINGS_SUGGESTION_ID = 'rebalance-bookings';
